import CookieBar from '#GameFrontend/components/ui/cookie-bar';
import { LoadingProvider } from '#GameFrontend/contexts/LoadingContext';
import Layout from '#GameFrontend/unauthorized/components/Layout';
import Main from '#GameFrontend/unauthorized/pages/Main';
import Register from '#GameFrontend/unauthorized/pages/Register';
import Terms from '#GameFrontend/unauthorized/pages/Terms';
import React, { Suspense } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './styles/fonts.css';
import './styles/globals.css';
import './styles/sprites.css';

const MenuHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return <>{children}</>;
};

function Unauthorized() {
	return (
		<LoadingProvider>
			<div className="unauthorized-layout">
				<Router>
					<CookieBar />
					<MenuHandler>
						<Suspense fallback={<div>Loading...</div>}>
							<Routes>
								<Route key="layout" path="/" element={<Layout />}>
									<Route index element={<Main />} />
									<Route path="verify/:emailIdentifier/:hash" element={<Main />} />
									<Route path="reset/:emailIdentifier/:hash" element={<Main />} />
									<Route key="terms" path="terms" element={<Terms />} />
									<Route key="register" path="register" element={<Register />} />
									<Route path="*" element={<Navigate to="/" replace />} />
								</Route>
							</Routes>
						</Suspense>
					</MenuHandler>
				</Router>
			</div>
		</LoadingProvider>
	);
}

export default Unauthorized;
